<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 260px;" class="mr-1">
								<v-text-field clearable dense label="课程名称" outlined v-model="query.courseName">
								</v-text-field>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status"
								item-text="statusName" item-value="id"  label="课程状态" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="info">查询</v-btn>
						</v-col>
					</v-row>
					
					<v-row dense class="mt-n5 mb-2">
						<v-col cols="12" class="ml-2">
							<v-btn @click="showAddDialog" small color="info">添加课程</v-btn>
						</v-col>
					</v-row>
					<v-divider></v-divider>
				</template>
				
				<template v-slot:item.status="{item}">
					<span v-if="item.status=='1'">正常</span>
					<span v-if="item.status=='0'" style="color:red">已作废</span>
				</template>
				<template v-slot:item.consumeType="{item}">
					<span v-if="item.consumeType=='1'">{{ consumeTypeName(item.consumeType) }}</span>
					<span v-if="item.consumeType=='2'" style="color:#E65100">{{ consumeTypeName(item.consumeType) }}</span>
				</template>
				<template v-slot:item.consumePrice="{item}">
					{{ item.consumePrice }}
				</template>

				<template v-slot:item.action="{item}">
					<v-btn @click.stop="showUpdate(item)" color="info" small>修改</v-btn>
					<v-btn v-if="item.status =='1'" @click.stop="frozen(item)" color="info" small class="ml-1">作废</v-btn>
					<v-btn v-if="item.status =='0'" @click.stop="free(item)" color="info" small class="ml-1">启用</v-btn>
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		
		<!-- 修改dialog -->
		<v-dialog title="修改课程" v-model="update.dialog" max-width="600" persistent>
			<v-card>
				<v-card-title>
					<span>修改课程信息</span>
					<v-spacer></v-spacer>
					<v-icon @click="update.dialog=false">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					<v-row dense>
						
						<v-col cols="12">
							<v-text-field label="课程名称" v-model="update.course.courseName" dense outlined></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-select :loading="modesLoading" :disabled="modesLoading" :items="consumeTypes" v-model="update.course.consumeType"
							item-text="typeText" item-value="typeValue"  label="扣费方式" dense outlined></v-select>
						</v-col>
						<v-col cols="12">
							<v-text-field type="number" label="标准课时单价" v-model="update.course.consumePrice" dense outlined></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="update.dialog=false">取消</v-btn>
					<v-btn @click="submitUpdateCourse" :loading="update.submiting" color="info">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<!-- 添加课程组件 -->
		<courseCreate :show="add.dialog" @cancel="add.dialog=false" @success="courseCreated"></courseCreate>
		
	</v-card>
</template>

<script>
	import {fetchAccountModes,consumeOptions} from '../../../config/accountModes'
	import utils from "../../../config/utils"
	import courseCreate from "../../../components/course_create.vue"
	export default {
		name: "course-list",
		components:{courseCreate},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '系统管理',
						disabled: true
					},
					{
						text: '课程管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						
						{
							text: '扣费方式',
							value: 'consumeType',
							sortable: false
						},
						{
							text: '标准课时单价',
							value: 'consumePrice',
							sortable: false
						},
						{
							text: '班级数',
							value: 'onlineClassQty',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				search: "",
				consumeTypes:[],
 modesLoading:false, modesError:"", originalConsumeType:"", modeShopId:"", modesRequest:0,
				statusItems:[
					{id:'',statusName:"全部"},
					{id:'1',statusName:"正常"},
					{id:'0',statusName:"已作废"},
				],
				selectShopList:[], //选择门店数据源
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					courseName: "",
					status: "1"
				},
				add: {
					dialog: false,
				},
				update: {
					dialog: false,
					submiting:false,
					course: {
						id:"",
						courseName: "",
						consumeType:"",
						consumePrice: "",
						briefDesc:""
					}
				},
			}
		},
		created() {
		
			this.getCourseList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getCourseList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getCourseList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getCourseList();
			},
			
			showAddDialog() {
				this.add.dialog = true;
			},
			
			getCourseList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/edu/course/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.courseName) {
					url += "&courseName=" + this.query.courseName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}


				this.axios.get(url).then(response => {
					
					console.log(response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			consumeTypeName(state){
				let stName = "未知";
				if (state === "1") {
					stName = "按课时扣费";
				} else if (state === "2") {
					stName = "按金额扣费";
				}
				return stName;
			},
			frozen(item){
				// api
				const that = this;
				let url = `/edu/course/frozen/${item.id}`;
							
			
				this.axios.post(url).catch(() => {
	
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("作废成功");
							that.getCourseList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			free(item){
				// api
				const that = this;
				let url = `/edu/course/free/${item.id}`;
							
			
				this.axios.post(url).catch(() => {
				
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("启用成功");
							that.getCourseList();
							
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			consumeTypeColor(state){
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				}
				
				return color;
			},
			courseStatusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			courseStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			courseCreated(){
				this.getCourseList();
				this.add.dialog = false;
			},
			async showUpdate(item) {
				this.update.dialog = true;
				this.update.course.id = item.id;
				this.update.course.courseName = item.courseName;
				this.update.course.consumeType = item.consumeType;
				this.update.course.consumePrice = item.consumePrice;
 this.originalConsumeType=item.consumeType;this.consumeTypes=[];this.modesLoading=true;this.modesError="";
 const seq=++this.modesRequest, shopId=utils.getCurrentShopId();this.modeShopId=String(shopId||"");
 try{const modes=await fetchAccountModes(this.axios,shopId);if(seq!==this.modesRequest)return;this.consumeTypes=consumeOptions.filter(x=>modes.includes(x.typeValue)||x.typeValue===item.consumeType).map(x=>({...x,typeText:x.typeText+(modes.includes(x.typeValue)?"":"（原扣费方式）")}))}
 catch(e){if(seq===this.modesRequest){this.modesError=e.message;this.$noty.error(e.message)}}
 finally{if(seq===this.modesRequest)this.modesLoading=false}
			},
			submitUpdateCourse() {
 if(this.modesLoading||this.update.submiting)return;
 if(this.modesError||!this.consumeTypes.some(x=>x.typeValue===this.update.course.consumeType)){this.$noty.error("请重新打开表单获取校区账户类型");return}
 if(this.modeShopId!==String(utils.getCurrentShopId()||"")){this.$noty.error("校区已变化，请重新打开表单");return}

			
				if (!this.update.course.courseName) {
					this.$noty.error('课程名称不能为空');
					return
				}
				
				if (!this.update.course.consumeType) {
					this.$noty.error('扣费方式不能为空');
					return
				}
				
				if (!this.update.course.consumePrice) {
					this.$noty.error('价格不能为空');
					return
				}
				this.update.submiting = true;
				// api
				const that = this;
				let url = `/edu/course/update`;
			
				const updateData = {
					...this.update.course
				}
				
				this.axios.post(url, updateData).catch(() => {
					that.update.submiting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.update.submiting = false;
							that.$noty.success("修改成功");
							that.update.dialog = false;
							that.getCourseList();
							
							return;
						} else {
							that.update.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.update.submiting = false;
						that.$noty.error('网络请求失败');
					}

				});
			},
			
			

		}
	}
</script>

<style>
</style>
